import i18nFactory from '@yandex-int/i18n';

import { LogHelpers } from '../../../service/LogHelpers/LogHelpers';
import { BroadmatchFragment } from '../../../typings/graphql-log';
import { allGoals, BroadmatchGroups, BroadmatchValue } from '../../../typings/log';
import { getValueFromApiFormat } from '../../common/common';

import * as keyset from './broadmatch.i18n';

const broadmatchI18N = i18nFactory(keyset);

export function prepareBroadmatchGroups(before?: BroadmatchFragment, after?: BroadmatchFragment): BroadmatchGroups {
    if (!before || !after) {
        throw Error('Некорректное значение ДРФ: нет данных');
    }

    const mappedBefore = {
            ['__typename']: '',
            ...before,
            goal: {
                ...before.goal,
                id: Number(getValueFromApiFormat(before.goal.id))
            }
        },
        mappedAfter = {
            ['__typename']: '',
            ...after,
            goal: {
                ...after.goal,
                id: Number(getValueFromApiFormat(after.goal.id))
            }
        },
        maxLength = Math.max(
            calcLimitLength(mappedBefore, mappedAfter),
            calcBroadmatchGoalLength(mappedBefore, mappedAfter)
        );

    return {
        before: mappedBefore,
        after: mappedAfter,
        maxLineLength: maxLength,
        alwaysNeedExpand: false,
        needExpand: LogHelpers.calcNotAlwaysNeedExpand(maxLength)
    };
}

function calcLimitLength(before: BroadmatchValue, after: BroadmatchValue): number {
    const { enabled: beforeEnabled, limit: beforeLimit } = before,
        { enabled: afterEnabled, limit: afterLimit } = after,
        isLimitDifferent = beforeEnabled === afterEnabled && beforeLimit !== afterLimit,
        limitStr = isLimitDifferent
            ? broadmatchI18N('campaign_broad_match_limit_changed', {
                  oldLimit: beforeLimit + '%',
                  newLimit: afterLimit + '%'
              })
            : broadmatchI18N('campaign_broad_match_limit', {
                  limit: !beforeEnabled && afterEnabled ? afterLimit : beforeLimit
              });

    return limitStr.length;
}

function calcBroadmatchGoalLength(before: BroadmatchValue, after: BroadmatchValue): number {
    const {
            goal: { id: beforeGoalId, name: beforeGoalName }
        } = before,
        {
            goal: { id: afterGoalId, name: afterGoalName }
        } = after,
        isEqual = beforeGoalId === afterGoalId;

    if (isEqual || beforeGoalId === undefined || afterGoalId === undefined) {
        const goalId = isEqual || beforeGoalId === undefined ? afterGoalId : beforeGoalId,
            goalName = isEqual || beforeGoalId === undefined ? afterGoalName : beforeGoalName,
            hasGoal = goalId !== undefined,
            goalText =
                goalId === allGoals
                    ? broadmatchI18N('campaign_broad_match_goal_all')
                    : broadmatchI18N('campaign_broad_match_goal_id', {
                          goalName: goalName
                      });
        return hasGoal ? goalText.length : 0;
    } else {
        const oldValueSpan =
                beforeGoalId === allGoals
                    ? broadmatchI18N('on-all-goals')
                    : broadmatchI18N('on-goal', { goalName: beforeGoalName }),
            newValueSpan =
                afterGoalId === allGoals
                    ? broadmatchI18N('on-all-goals')
                    : broadmatchI18N('on-goal', { goalName: afterGoalName }),
            goalString = broadmatchI18N('campaign_broad_match_goal_changed', {
                oldGoal: oldValueSpan,
                newGoal: newValueSpan
            });

        return goalString.length;
    }
}
